<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="ORIM-Dedication--Front-Matter-">To Michael, Holly, Terry, Leroy, Sue, for believing in the starship before it existed;</p>
<p class="ORIM-Dedication--Front-Matter-">To Ryan for the video and Steve for the t-shirts; and, of course, To Majel and Gene for encouragement at the airport.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Starfarers_1245.vue?42773ae5